import counsellor from '../assets/images/counsellor.png';
import onewindow from '../assets/images/oneWindowLogo.png';
// import standardLoader from './images/standardLoader.gif'
import success from './images/success.png';
import campusrootLogo from "./images/CampusrootLogo.png";
import deleteIcon from "./images/deleteIcon.png";
import family from './images/family.png';
import education from './images/education.png';
import profile from './images/profile.png';
import extracurricular from './images/extracurricular.png';
import testscores from './images/testscores.png';
import workExperience from './images/workExperience.png';
import preferences from './images/preferences.png';
import skills from './images/skills.png';
import standardLoader from './images/standardLoader.gif'
import pdfIcon from './images/pdf-icon.png';
import logout from './images/logout.png';
import noData from './images/noData.png';
import Climate from './images/climate.png';
import HomeRent from './images/homerent.png';
import Scholarship from './images/scholarship.png';
import facebookIcon from "./images/facebook-icon.gif";
import instagramLogo from "./images/instagram-icon.gif";
import linkedInIcon from "./images/linkedin-icon.png";
import twitterIcon from "./images/twitter-icon.gif";
import youtubeIcon from "./images/youtube-icon.gif";
import emailVerified from '../assets/images/emailVerified.png';
import emailFailed from '../assets/images/emailFailed.jpeg';
import privacy from '../assets/images/privacy.png';
import checklist from '../assets/images/check_list.gif';
import underline from '../assets/images/underline.svg';
import calendar from '../assets/images/calendar.gif';
import selected from '../assets/images/selected.png';
import degreeIcon from '../assets/images/degreeIcon.png';
import Australia from "./images/Australia.png";
import Canada from "./images/Canada.png";
import Ireland from "./images/Ireland.png";
import UnitedStates from "./images/UnitedStates.png";
import UnitedKingdom from "./images/UnitedKingdom.png";
import NewZealand from "./images/NewZealand.png";
import Websitelink from '../assets/images/websitelink.png';
import Facebooklink from '../assets/images/Facebooklink.png';
import Instalink from '../assets/images/instalink.png';
import Youtube from '../assets/images/youtube.png';
import Twitter from '../assets/images/twitter.png';
import Snapchat from '../assets/images/snapchat.png';
import chaticon from '../assets/images/chaticon.png';
import cancelledIcon from '../assets/images/cancelledIcon.png';
import Grescore from '../assets/images/grescore.png';
import Disciplines from '../assets/images/disciplines.png';
import sendIcon from '../assets/images/sendIcon.png';
import seen from '../assets/images/seen.png';
import delivered from '../assets/images/delivered.png';
import homepage1 from '../assets/images/homepage1.png';
import homepage2 from '../assets/images/homepage2.png';
import homepage3 from '../assets/images/homepage3.png';
import universitybuilding from '../assets/images/universitybuilding.png';
import courseicon from '../assets/images/courseicon.png';
import safe from '../assets/images/safe.png';
import moderate from '../assets/images/moderate.png';
import noRecommend from '../assets/images/norecommend.png';
import noMeetings from '../assets/images/nomeetings.png';
import advisors from '../assets/images/advisors.png';
import groupusers from '../assets/images/groupusers.png';
import artificial from '../assets/images/artificial.png';
import section2 from '../assets/images/section2.png';
import section3 from '../assets/images/section3.png';
import explore from '../assets/images/explore.png';
import section1 from '../assets/images/section1.png';
import profilebg from '../assets/images/profilebg.png';
import activeai from '../assets/images/activeai.png';
import inactiveai from '../assets/images/inactiveai.png';
import img1 from '../assets/images/img1.png';
import img2 from '../assets/images/img2.png';
import img3 from '../assets/images/img3.png';
import img4 from '../assets/images/img4.png';
import readingBook from '../assets/images/reading-book 1.png';
import maskGroup from '../assets/images/Maskgroup.png';
import universityMask from '../assets/images/universityMask.png';
import location from '../assets/images/location.png';
import safety from '../assets/images/safety.png';
import professors from '../assets/images/professors.png';
import party from '../assets/images/party.png';
import studentlife from '../assets/images/studentlife.png';
import value from '../assets/images/value.png';
import dorms from '../assets/images/dorms.png';
import food from '../assets/images/food.png';
import diversity from '../assets/images/diversity.png';
import campus from '../assets/images/campus.png';
import athletics from '../assets/images/athletics.png';
import cart from '../assets/images/cart.png';
import dashboard from '../assets/images/dashboard.png';
import documents from '../assets/images/documents.png';
import experts from '../assets/images/experts.png';
import flight from '../assets/images/flight.png';
import orders from '../assets/images/orders.png';
import passport from '../assets/images/passport.png';
import personal from '../assets/images/personal.png';
import products from '../assets/images/products.png';
import recommendations from '../assets/images/recommendations.png';
import wishlist from '../assets/images/wishlist.png';
import airecommend from '../assets/images/airecommend.png';
import countriescard from '../assets/images/countriescard.jpeg';
import recommended from '../assets/images/recommended.png';
import loginImg from '../assets/images/loginImg.png';
import flightRight from '../assets/images/flightRight.png';
import errorMsg from '../assets/images/errorMsg.png';
import chooseBest from '../assets/images/chooseBest.png';
import confusedImg from '../assets/images/confusedImg.png';
import exploremore from '../assets/images/exploremore.png';
import successMsg from '../assets/images/successMsg.png';
import calender from '../assets/images/calendar.png';
import meeting from '../assets/images/meeting.png';
import budget from '../assets/images/budget.png';
import city from '../assets/images/city.png';
import country from '../assets/images/country.png';
import startDate from '../assets/images/startDate.png';
import state from '../assets/images/state.png';
import studyLevel from '../assets/images/studyLevel.png';
import discipline from '../assets/images/discipline.png';
import deleteImg from '../assets/images/delete.png';
import studyMode from '../assets/images/studyMode.png';
import subDiscipline from '../assets/images/subDiscipline.png';
import universityType from '../assets/images/universityType.png';
import filterIcon from '../assets/images/filterIcon.png';
import arrow from '../assets/images/arrow.png';
import noarrow from '../assets/images/noarrow.png';
import ai from '../assets/images/ai.png';
import googlePlay from '../assets/images/googlePlay.png';
import appStore from '../assets/images/appStore.png';
import Confused from '../assets/images/Confused.png';
import Circle from '../assets/images/circle.png';
import activeIcon from '../assets/images/activeIcon.png';
import Features1 from '../assets/images/Features1.png';
import Features2 from '../assets/images/Features2.png';
import Features3 from '../assets/images/Features3.png';
import Features4 from '../assets/images/Features4.png';
import diffImage from '../assets/images/diffImage.png';
import industry from '../assets/images/industry.png';
import loan from '../assets/images/loan.png';
import prof from '../assets/images/prof.png';
import scholar from '../assets/images/scholar.png';
import visa from '../assets/images/visa.png';
import aeroplane from '../assets/images/aeroplane.png';
import airc from '../assets/images/airc.png';
import icef from '../assets/images/icef.png';
import nafsa from '../assets/images/nafsa.png';
import testReady from '../assets/images/testReady.png';
import sec2Img1 from '../assets/images/sec2Img1.jpeg';
import usa from '../assets/images/usa.png';
import sec2Img2 from '../assets/images/sec2Img2.jpeg';
import sec2Img3 from '../assets/images/sec2Img3.jpeg';
import sec2Img4 from '../assets/images/sec2Img4.png';
import sec2Img5 from '../assets/images/sec2Img5.png';
import sec2Img6 from '../assets/images/sec2Img6.png';
import sec2Img7 from '../assets/images/sec2Img7.png';
import sec2Img8 from '../assets/images/sec2Img8.png';
import sec2Img9 from '../assets/images/sec2Img9.png';
import sec2Img10 from '../assets/images/sec2Img10.png';
import sec2Img11 from '../assets/images/sec2Img11.png';
import sec2Img12 from '../assets/images/sec2Img12.png';
import sec2Img13 from '../assets/images/sec2Img13.png';
import universType from '../assets/images/universType.png';
import establishedYear from '../assets/images/establishedYear.png';
import deadlines from '../assets/images/deadlines.png';
import endDate from '../assets/images/endDate.png';
import testimonial from '../assets/images/testimonial.png';
import office from '../assets/images/office.png';
import select from '../assets/images/select.png'
import info from '../assets/images/info.png'
import exclusiveOffer from '../assets/images/1Exclusive offer illustration.png'
import careersupport from '../assets/images/2career support illustration.png'
import financialassist from '../assets/images/3Financial Assistance illustration.png'
import celebrationsuccess from '../assets/images/4congragulations illustration.png'
import singapore from '../assets/images/Singapore.png'
import uae from '../assets/images/Uae.jpg'
import netherlands from '../assets/images/Netherlands.png'
import italy from '../assets/images/Italy.png'
import ai1 from '../assets/images/ai1.png'
import universitytil from '../assets/images/universitySelectiontill.png'
import applicationAssitance from '../assets/images/applicationassistance.png'
import educatioloanOrange from '../assets/images/educationloanorange.png'
import scholorshipOrange from '../assets/images/scholarshiporange.png'
import soppurple from '../assets/images/soppurple.png'
import VisaTeal from '../assets/images/visateal.png'
import AccomidationTeal from '../assets/images/accomidationteal.png'
import flightRed from '../assets/images/flightred.png'
import SuitcaseOrange from '../assets/images/suitcaseorange.png'
import BookTeal from '../assets/images/Bookteal.png'
import UniTeal from '../assets/images/uniteal.png'
import SafeTeal from '../assets/images/Safeteal.png'
import ModerateTeal from '../assets/images/Moderate teal.png'
import AmbiousTeal from '../assets/images/Ambitiousteal.png'
import Explore7 from '../assets/images/explore7.png'
import Calender from '../assets/images/Calender.png'
import RightArrow from '../assets/images/right-arrow 5.png'
import GroupUp from '../assets/images/groupUp.png'
import GroupDown from '../assets/images/Groupdown.png'
import Dollar1 from '../assets/images/dollar1.png'
import GraduateHat from '../assets/images/GraduateHat.png'
import Dull from '../assets/images/dull.png'
import Calender1 from '../assets/images/calender1.png'
import Timmer from '../assets/images/timer.png'
import CheckboxWrongRed from '../assets/images/checkboxwrongred.png'
import CheckboxRightTeal from '../assets/images/checkboxrightteal.png'
import SuitcasePurple from '../assets/images/suitcasepurple.png'
import Rupeeteal from '../assets/images/rupee.png'
import Coin from '../assets/images/coin.png'
import campusRootLogo from '../assets/images/campusroot-logo.png'
import NationalTeal from '../assets/images/National_Teal.png'
import InternationalPeach from '../assets/images/International_peach.png'
import MoneyBag from '../assets/images/Moneybag.png'
import BookDashboard from '../assets/images/BookDashboard.png'
import UniDashboard from '../assets/images/UniDashboard.png'
import SafeDashboard from '../assets/images/SafeDashboard.png'
import ModerateDashboard from '../assets/images/ModerateDashboard.png'
import AmbitiousDashboard from '../assets/images/AmbitiousDashboard.png'
import SopDashboard from '../assets/images/SopDashboard.png'
import TestDashboard from '../assets/images/3. TestDashboard.png'
import ProfileDashboard from '../assets/images/4.ProfileDashboard.png'
import ReviewsIllustration from '../assets/images/Reviews.png'
import ReviewQuote from '../assets/images/reviewquote.png'
import SignUpBg from '../assets/images/Signup_bg.png'
import ReactangleTab from '../assets/images/Rectangle.png'
import CreateTab from '../assets/images/CreateTab.png'
import GenerateTab from '../assets/images/Generate.png'
import HpProfile from '../assets/images/HpProfile.png'
import HpScholorship from '../assets/images/HPScholorship.png'
import HpAnyTime from '../assets/images/HPAnytime.png'
import HpSmart from '../assets/images/HpSmart.png'
import HpVisa from '../assets/images/HpVisa.png'
import HpFast from '../assets/images/HpFastTrack.png'
import HpAvaIllu from '../assets/images/HP AVA mockup with illustration.png'
import HPAva from '../assets/images/HP AVA mockup.png'
import HowItWorks1 from '../assets/images/How it works icon1.png'
import HowItWorks2 from '../assets/images/How it works icon 2.png'
import HowItWorks3 from '../assets/images/How it works icon 3.png'
import HowItWorks4 from '../assets/images/How it works icon 4.png'
import OurSucessStory1 from '../assets/images/Our success story icon 1.png'
import OurSucessStory2 from '../assets/images/Our success story icon 2.png'
import OurSucessStory3 from '../assets/images/Our success story icon 3.png'
import OurSucessStory4 from '../assets/images/Our success story icon 4.png'
import OurSucessStory5 from '../assets/images/Our success story icon 5.png'
import OurSucessStory6 from '../assets/images/Our success story icon 6.png'
import FindIllu from '../assets/images/Find perfect program illustration.png'
import BeTestIllu from '../assets/images/be test ready illustration.png'
import BeTestBg from '../assets/images/Be test ready bg.png'
import StudySupport from '../assets/images/singup_bg2.png'
import TestReadyillU from '../assets/images/be test ready illustration.png'
import TestPeach from '../assets/images/TestPeachBg.png'
import TestPeal from '../assets/images/TestPealBg.png'
import TestPurple from '../assets/images/TestPurple.png'
import CareerBanner from '../assets/images/Careers banner BG.png'
import WhyChooseIllustration from '../assets/images/Why choose a career illustration purple.png'
import CareerInternship from '../assets/images/Careers internship Illustration peach.png'
import CompetetiveCompensation from '../assets/images/1.Competitive Compensation .png'
import LearningDevelopment from '../assets/images/2.Learning & Development.png'
import FamilyFriend from '../assets/images/3.Family-Friendly Policies .png'
import Healthandwellness from '../assets/images/4.Health & Wellness .png'
import PaidTimeOff from '../assets/images/5.Paid Time Off .png'
import RetirementPlans from '../assets/images/6.Retirement Plans.png'
import EmpoweringWomen from '../assets/images/Empowering women illustration.png'
import ContactUsIllustration from '../assets/images/contact us image.png'
import OurMission from '../assets/images/Our mission icons.png'
import OurVision from '../assets/images/Our vission icons.png'
import StudentCentric from '../assets/images/Student centric icon.png'
import Excellence from '../assets/images/Eccellence.png'
import Integrity from '../assets/images/Integrity.png'
import partnership from '../assets/images/partnership.png'
import ExpertGuidance from '../assets/images/Expert guidance icon.png'
import GlobalNetwork from '../assets/images/Global network icon.png'
import SuccessRate from '../assets/images/Success rate icon.png'
import Comprehensive from '../assets/images/Comprehensive support icon.png'
import ScholorshipAssistance from '../assets/images/Scholarship assistance ison.png'
import PostArrivalSupport from '../assets/images/Post arrival support icon.png'
import TestPrepIcon from '../assets/images/TestPrepicon.png'
import WhyChooseIcon from '../assets/images/WhyChoose.png'
import BeTestMobile from '../assets/images/BeTestMobile.png'
import PesLogo from '../assets/images/pes-logo.png'
import LpuLogo from '../assets/images/lpu-logo.png'
import NitLogo from '../assets/images/nit-logo.png'






const Images = {
  counsellor:counsellor,
    standardLoader:standardLoader,
    success:success,
    noData:noData,
    recommended:recommended,
    chaticon:chaticon,
    sendIcon:sendIcon,
  SopDashboard:SopDashboard,
  TestDashboard:TestDashboard,
  ProfileDashboard:ProfileDashboard,
  AmbitiousDashboard:AmbitiousDashboard,
  ModerateDashboard:ModerateDashboard,
  SafeDashboard:SafeDashboard,
  testimonial:testimonial,
  office:office,
  universType:universType,
  establishedYear:establishedYear,
  deadlines:deadlines,
  endDate:endDate,
  sec2Img1:sec2Img1,
  sec2Img2:sec2Img2,
  sec2Img3:sec2Img3,
  sec2Img4:sec2Img4,
  sec2Img5:sec2Img5,
  sec2Img6:sec2Img6,
  sec2Img7:sec2Img7,
  sec2Img8:sec2Img8,
  sec2Img9:sec2Img9,
  sec2Img10:sec2Img10,
  sec2Img11:sec2Img11,
  sec2Img12:sec2Img12,
  sec2Img13:sec2Img13,
  airc:airc,
  icef:icef,
  nafsa:nafsa,
  testReady:testReady,
  usa:usa,
  Features1:Features1,
  Features2:Features2,
  Features3:Features3,
  Features4:Features4,
  diffImage:diffImage,
  industry:industry,
  loan:loan,
  prof:prof,
  scholar:scholar,
  visa:visa,
  aeroplane:aeroplane,
  arrow:arrow,
  ai:ai,
  noarrow:noarrow,
  budget:budget,
  Confused:Confused,
  Circle:Circle,
  activeIcon:activeIcon,
  city:city,
  filterIcon:filterIcon,
  country:country,
  startDate:startDate,
  state:state,
  discipline:discipline,
  studyLevel:studyLevel,
  studyMode:studyMode,
  subDiscipline:subDiscipline,
  universityType:universityType,
  calender:calender,
  delete:deleteImg,
  meeting:meeting,
  cart:cart,
  chooseBest:chooseBest,
  confusedImg:confusedImg,
  exploremore:exploremore,
  errorMsg:errorMsg,
  successMsg:successMsg,
  countriescard:countriescard,
  airecommend:airecommend,
  flightRight:flightRight,
  dashboard:dashboard,
  documents:documents,
  loginImg:loginImg,
  experts:experts,
  flight:flight,
  orders:orders,
  passport:passport,
  personal:personal,
  products:products,
  location:location,
  safety:safety,
  professors:professors,
  recommendations:recommendations,
  wishlist:wishlist,
  party:party,
  studentlife:studentlife,
  value:value,
  dorms:dorms,
  food:food,
  diversity:diversity,
  campus:campus,
  athletics:athletics,
  img1:img1,
  img2:img2,
  img3:img3,
  img4:img4,
  readingBook:readingBook,
  maskGroup:maskGroup,
  universityMask:universityMask,
  section1:section1,
  profilebg:profilebg,
  activeai:activeai,
  inactiveai:inactiveai,
  universitybuilding:universitybuilding,
  moderate:moderate,
  section3:section3,
  groupusers :groupusers ,
  artificial:artificial,
  safe:safe,
  section2:section2,
  explore:explore,
  advisors:advisors,
  noRecommend:noRecommend,
  noMeetings:noMeetings,
  courseicon:courseicon,
  homepage1:homepage1,
  homepage2:homepage2,
  homepage3:homepage3,
  seen:seen,
  delivered:delivered,
  Grescore:Grescore,
  Disciplines:Disciplines,
  cancelledIcon:cancelledIcon,
  Youtube:Youtube,
  Twitter:Twitter,
  Snapchat:Snapchat,
  Facebooklink:Facebooklink,
  Websitelink:Websitelink,
  Instalink:Instalink,
  Australia: Australia,
  Canada: Canada,
  Ireland: Ireland,
  UnitedStates: UnitedStates,
  UnitedKingdom: UnitedKingdom,
  NewZealand: NewZealand,
  selected:selected,
  degreeIcon:degreeIcon,
  calendar:calendar,
  underline:underline,
  checklist:checklist,
  Scholarship:Scholarship,
  Climate:Climate,
  HomeRent:HomeRent,
  oneWindow: onewindow,
  deleteIcon:deleteIcon,
  pdfIcon:pdfIcon,
  family:family,
  education:education,
  proile:profile,
  extracurricular:extracurricular,
  workExperience:workExperience,
  testscores:testscores,
  preferences:preferences,
  skills:skills,
  logout:logout,
  facebookIcon: facebookIcon,
  instagramLogo: instagramLogo,
  linkedInIcon: linkedInIcon,
  twitterIcon: twitterIcon,
  youtubeIcon: youtubeIcon,
  googlePlay:googlePlay,
  appStore:appStore,
  emailVerified:emailVerified,
  emailFailed:emailFailed,
  privacy:privacy,
  select:select,
  info:info,
  exclusiveOffer:exclusiveOffer,
  careersupport:careersupport,
  financialassist:financialassist,
  celebrationsuccess:celebrationsuccess,
  singapore:singapore,
  uae:uae,
  netherlands:netherlands,
  italy:italy,
  ai1:ai1,
  universitytil:universitytil,
  applicationAssitance:applicationAssitance,
  educatioloanOrange:educatioloanOrange,
  scholorshipOrange:scholorshipOrange,
  soppurple:soppurple,
  VisaTeal:VisaTeal,
  AccomidationTeal:AccomidationTeal,
  flightRed:flightRed,
  SuitcaseOrange:SuitcaseOrange,
  BookTeal:BookTeal,
  UniTeal:UniTeal,
  SafeTeal:SafeTeal,
  ModerateTeal:ModerateTeal,
  AmbiousTeal:AmbiousTeal,
  Explore7:Explore7,
  Calender:Calender,
  RightArrow:RightArrow,
  GroupUp:GroupUp,
  GroupDown:GroupDown,
  Dollar1:Dollar1,
  GraduateHat:GraduateHat,
  Dull:Dull,
  Calender1:Calender1,
  Timmer:Timmer,
  CheckboxWrongRed:CheckboxWrongRed,
  CheckboxRightTeal:CheckboxRightTeal,
  SuitcasePurple:SuitcasePurple,
  Rupeeteal:Rupeeteal,
  Coin:Coin,
  campusRootLogo: campusRootLogo,
  NationalTeal:NationalTeal,
  InternationalPeach:InternationalPeach,
  MoneyBag:MoneyBag,
  UniDashboard:UniDashboard,
  BookDashboard:BookDashboard,
  ReviewsIllustration:ReviewsIllustration,
  ReviewQuote:ReviewQuote,
  SignUpBg:SignUpBg,
  ReactangleTab:ReactangleTab,
  CreateTab:CreateTab,
  GenerateTab:GenerateTab,
  HpAnyTime:HpAnyTime,
  HpProfile:HpProfile,
  HpScholorship:HpScholorship,
  HpSmart:HpSmart,
  HpVisa:HpVisa,
  HpAvaIllu:HpAvaIllu,
  HPAva:HPAva,
  HowItWorks1:HowItWorks1,
  HowItWorks2:HowItWorks2,
  HowItWorks3:HowItWorks3,
  HowItWorks4:HowItWorks4,
  OurSucessStory1:OurSucessStory1,
  OurSucessStory2:OurSucessStory2,
  OurSucessStory3:OurSucessStory3,
  OurSucessStory4:OurSucessStory4,
  OurSucessStory5:OurSucessStory5,
  OurSucessStory6:OurSucessStory6,
  FindIllu:FindIllu,
  BeTestIllu:BeTestIllu,
  BeTestBg:BeTestBg,
  HpFast:HpFast,
  StudySupport:StudySupport,
  TestReadyillU:TestReadyillU,
  TestPeach:TestPeach,
  TestPeal:TestPeal,
  TestPurple:TestPurple,
  CareerBanner:CareerBanner,
  WhyChooseIllustration:WhyChooseIllustration,
  CareerInternship:CareerInternship,
  CompetetiveCompensation:CompetetiveCompensation,
  LearningDevelopment:LearningDevelopment,
  FamilyFriend:FamilyFriend,
  Healthandwellness:Healthandwellness,
  PaidTimeOff:PaidTimeOff,
  RetirementPlans:RetirementPlans,
  EmpoweringWomen:EmpoweringWomen,
  ContactUsIllustration:ContactUsIllustration,
  OurMission:OurMission,
  OurVision: OurVision,
  StudentCentric:StudentCentric,
  Excellence:Excellence,
  Integrity:Integrity,
  partnership:partnership,
  ExpertGuidance:ExpertGuidance,
  GlobalNetwork:GlobalNetwork,
  SuccessRate:SuccessRate,
  Comprehensive:Comprehensive,
  ScholorshipAssistance:ScholorshipAssistance,
  PostArrivalSupport:PostArrivalSupport,
  TestPrepIcon:TestPrepIcon,
  WhyChooseIcon:WhyChooseIcon,
  BeTestMobile:BeTestMobile,
  PesLogo:PesLogo,
  LpuLogo:LpuLogo,
  NitLogo:NitLogo

};

export default Images;
